import './App.css'
import { useEffect, useRef, useState } from 'react'
import HeaderBar from './header'
import Drawer, { DrawerHandle } from './features/drawer'
import CaptureButton from './features/capture/button'
import Form from './common/Modals/Form'
import { useAuth } from './provider/authentication'
import Login from './features/login'
import AVPlayer from './features/AVPlayer'
import { useWebsocket } from './provider/websocket'
import { checkLogin } from './api/endpoints'
import type { ActiveInstance } from '@expostreamer/shared-types'
import styles from './style'

function App() {
  const { accessToken, setAccessToken, group, setGroup, isAdmin } = useAuth()
  const { setIsWebsocketLoginReady } = useWebsocket()
  const drawerRef = useRef<DrawerHandle>(null)
  const [isDrawerOpen, setDrawerOpen] = useState(false)
  const [instanceList, setInstanceList] = useState<ActiveInstance[]>([])

  const [diplayStartRecordForm, setDisplayStartRecordForm] = useState(false)
  const [isCapturing, setIsCapturing] = useState(false)

  useEffect(() => {
    if (!accessToken) return
    checkLogin().then(({ ok, data }) => {
      if (!ok || !data.valid) {
        setAccessToken(null)
        setGroup(null)
      } else {
        setGroup(data.group)
        setIsWebsocketLoginReady(true)
      }
    })
  }, [accessToken, setAccessToken, setGroup, setIsWebsocketLoginReady])

  if (!accessToken) return <Login />

  // Role not resolved yet (checkLogin hasn't returned) — avoid flashing the
  // wrong UI for either role.
  if (group === null) return <div className='App' />

  if (!isAdmin) {
    return (
      <div className='App'>
        <HeaderBar isAdmin={false} />
        <div style={styles.playerRow}>
          <AVPlayer />
        </div>
      </div>
    )
  }

  return (
    <div className='App'>
      <HeaderBar
        isAdmin
        drawerRef={drawerRef}
        isDrawerOpen={isDrawerOpen}
        setDrawerOpen={setDrawerOpen}
      />
      <div style={styles.playerRow}>
        <AVPlayer />
        <Drawer
          setInstanceList={setInstanceList}
          instanceList={instanceList}
          ref={drawerRef}
          open={isDrawerOpen}
        />
      </div>
      <Form
        display={diplayStartRecordForm}
        setDisplay={setDisplayStartRecordForm}
        setIsCapturing={setIsCapturing}
      />
      {false ? (
        <CaptureButton
          onRightClick={() => {
            setDisplayStartRecordForm(!diplayStartRecordForm)
          }}
          setIsCapturing={setIsCapturing}
          isCapturing={isCapturing}
        />
      ) : null}
    </div>
  )
}

export default App
